import React from 'react';
import './Pagination.scss';

const Pagination = () => {
  return (
    <div className='paginationWrapper'>
      <nav aria-label="Page navigation example">
        <ul className="pagination">
          <li className="page-item"><a className="page-link" href="#"><i class="fa-solid fa-chevron-left"></i></a></li>
          <li className="page-item"><a className="page-link" href="#">1</a></li>
          <li className="page-item"><a className="page-link" href="#">2</a></li>
          <li className="page-item"><a className="page-link" href="#">3</a></li>
          <li className="page-item"><a className="page-link" href="#">4</a></li>
          <li className="page-item"><a className="page-link" href="#">5</a></li>
          <li className="page-item"><a className="page-link" href="#">6</a></li>
          <li className="page-item"><a className="page-link" href="#">7</a></li>
          <li className="page-item"><a className="page-link" href="#">8</a></li>
          <li className="page-item"><a className="page-link" href="#">9</a></li>
          <li className="page-item"><a className="page-link" href="#">10</a></li>
          <li className="page-item"><a className="page-link" href="#"><i class="fa-solid fa-chevron-right"></i></a></li>
        </ul>
      </nav>
    </div>
  )
}
export default Pagination;